/*
  *******************************************************
  Author: Loren Hayden
  Filename: Sortable.js
  Created: 2019-10-24
  Modified: 2019-10-24
  *******************************************************
  Purpose: To sort a list of named values pair lists
  (a.k.a a result set from the database)
  *******************************************************
*/

// *************************************************
// Sortable Prototype
// Parameter Examples:
//            dataset: [ 
//                    {"ADDRESS":"123 Funny Farm Ave.", "CITY":"Las Vegas","STATE":"Nevada","ZIP":"98120","COST": 5.257,"OPENDATE":"2019-10-15" },
//                    {"ADDRESS":"123 Funny Farm Blvd.", "CITY":"Las Vegas","STATE":"Nevada","ZIP":"98121","COST": 7.677123, "OPENDATE": "2019-11-12" },
//                    {"ADDRESS":"123 Funny Farm Street.", "CITY":"Las Vegas","STATE":"Nevada","ZIP":"98122","COST": 2.1381712, "OPENDATE":2019-12-01" }
//                  ] // Dataset 
//
//            option: { "key":"ADDRESS", "direction":"asc", , "datatype":"string" }
//                    {  "key":"ADDRESS", "direction":"asc", , "datatype":"string", precision: "2" }
// valid directions: asc, desc
// valid datatypes: string, date, integer, float

// Initialize the Sortable prototype
function DatasetSortable( dataset, option ) {
  // Verify the dataset variable is a valid array 
  if( Array.isArray( dataset ) === true ) {
    this.dataset = dataset === ( undefined || null || '' ) ? [] : dataset;  
    this.option = option === ( undefined || null || '' ) ? {} : option;      
  } 
}

// Sort the object array with options
// 
DatasetSortable.prototype.Sort = function( ) {
  let sortedDataset = [];

  if( this.dataset.length === 0 ) {
    return [];
  }
  
  const option = this.option;
  const key = option.key === undefined ? '' : option.key;
  const direction = option.direction === ( undefined || null || '' )  ? 'asc' : option.direction.toLowerCase();
  const datatype = option.datatype === ( undefined || null || '' ) ? 'string' : option.datatype.toLowerCase();
  const precision = option.precision === ( undefined || null || '' ) ? 0 : option.precision;
  const dataset = this.dataset;

  let arrayItems = [];
  let arrayIndices = {};
  let rowIndex = 0;

  for( rowIndex = 0; rowIndex < dataset.length; rowIndex++ ) {
    let value;
    const row = dataset[ rowIndex ];
    if( datatype === "integer" ) {
      value = parseInt( row[ key ], 10 );
    } else if( datatype === "float" ) {
      value = parseFloat( row[ key ].toFixed( precision ) );
    } else {
      value = row[ key ] === ( undefined || null ) ? '' : row[ key ];
    }
  
    // Insert the array item
    arrayItems.push( value );
    
    // initialize the array index if it does not exit
    if( arrayIndices[ value ] === undefined ) {
      arrayIndices[ value ] = [];
    }
    // Add the array index
    arrayIndices[ value ].push( rowIndex );
  }
 
  let sortedArrayItems;
  if( datatype === "integer" ) {
    sortedArrayItems = new Uint32Array( arrayItems );
    sortedArrayItems = sortedArrayItems.sort();
  } else {
    sortedArrayItems = arrayItems.sort();
  }

  let lastSortedKey = undefined;
  for( rowIndex = 0; rowIndex < sortedArrayItems.length; rowIndex++ ) {
    let sortedKey;
    sortedKey = sortedArrayItems[ rowIndex ];
    if( lastSortedKey !== sortedKey ) {
      let sortedIndexArray = arrayIndices[ sortedKey ];
      if( sortedIndexArray !== undefined ) {
        while( sortedIndexArray.length !== 0 ) {
          const sortedIndex = sortedIndexArray.pop();
          const row = dataset[ sortedIndex ];
          if( direction === 'desc') {
            sortedDataset.unshift( row );
          } else {
            sortedDataset.push( row );
          }
        }
      }
    }
    lastSortedKey = sortedKey
  }
  return sortedDataset;
}

export default DatasetSortable;


// WEBPACK FOOTER //
// ./src/prototypes/DatasetSortable.js